import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import Weather from './Weather'
import ReactTimeout from 'react-timeout'

import { db } from '../../firebase.js'

import { formatDateForFeaturedLink } from '../../helpers.js'

class Sidebar extends Component {
	constructor() {
		super()
		this.state = {
			isLoading: true,
			//properties: text, date, link, image
			topFeatured: {},
			botFeatured: {}
		}
	}

	componentDidMount() {
		const dbFeaturedLinks = db.ref('featuredLinks')
    dbFeaturedLinks.on('value', (snapshot) => {
			let featuredLinks = snapshot.val()
			this.setState({
				isLoading: false,
				topFeatured: featuredLinks.top,
				botFeatured: featuredLinks.bot
			})
		})
	}
	
	componentWillUnmount() {
		const dbFeaturedLinks = db.ref('featuredLinks')
		dbFeaturedLinks.off()		
  }
	
  render() {
		let top = this.state.topFeatured
		let bot = this.state.botFeatured
		let topFormattedDate = this.state.isLoading ? "" : formatDateForFeaturedLink(top.date)
		let botFormattedDate = this.state.isLoading ? "" : formatDateForFeaturedLink(bot.date)

    return (
			<aside className="leftbar pathway bg-white card pa2 w-30-l tc order-1 order-0-l mr2-l">
				<a href={top.link} 
					style={{backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.60),rgba(0, 0, 0, 0.60)),url("+top.img+")"}}
					target="_blank" 
					className="featured dim no-underline mb2 pa2 h4 fw1 f3 near-white open-sans-cond flex flex-column justify-center"
					rel="noopener noreferrer">
					<p>
						{top.text}<br/>
						{topFormattedDate}
					</p>
				</a>
				<a href={bot.link} 
					style={{backgroundImage: "linear-gradient(rgba(0, 0, 0, 0.60),rgba(0, 0, 0, 0.60)),url("+bot.img+")"}}
					target="_blank" 
					className="featured dim no-underline mb2 pa2 h4 fw1 f3 near-white open-sans-cond flex flex-column justify-center"
					rel="noopener noreferrer">
					<p>
						{bot.text}<br/>
						{botFormattedDate}
					</p>
				</a>
				<Link to="/directory" className="f2rem bg-dark-gray no-underline hover-bg-gray bg-animate mb2 pa2 near-white db">Local Directory</Link>
				<Link to="/calendar" className="f2rem bg-dark-gray no-underline hover-bg-gray bg-animate mb2 pa2 near-white db">Event Calendar</Link>
				<Link to="/living" className="f2rem bg-dark-gray no-underline hover-bg-gray bg-animate mb2 pa2 near-white db">Living in Eureka</Link>
				<Link to="/history" className="f2rem bg-dark-gray no-underline hover-bg-gray bg-animate mb2 pa2 near-white db">History</Link>
				<a className="f2rem bg-dark-gray no-underline hover-bg-gray bg-animate mb2 pa2 near-white db" href="http://KBRealtyTeamSTL.com">Real Estate</a>
				<div className="weather mb2 db">
					<Weather/>
				</div>
				<a className="f2rem bg-fb-blue no-underline hover-bg-gray bg-animate mb2 pa2 near-white db" href="https://www.facebook.com/eurekamissouri/">Facebook</a>
      </aside>
    )
  }
}
export default ReactTimeout(Sidebar)


// WEBPACK FOOTER //
// ./src/components/multi/Sidebar.js